// Module
var code = "<span class=\"option\" ng-class=\"{ selected: vm.selected === option }\" ng-repeat=\"option in vm.options\" ng-bind=\"option\" ng-click=\"vm.selectOption(option)\" tabindex=\"-1\"></span> ";
// Exports
module.exports = code;